import { render } from "./ProfileEditEducations.vue?vue&type=template&id=a321b98c&scoped=true&ts=true"
import script from "./ProfileEditEducations.vue?vue&type=script&lang=ts"
export * from "./ProfileEditEducations.vue?vue&type=script&lang=ts"

import "./ProfileEditEducations.vue?vue&type=style&index=0&id=a321b98c&scoped=true&lang=css"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a321b98c"]])

export default __exports__